import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=43c95f8e&"
import script from "./TaskListItem.vue?vue&type=script&lang=js&"
export * from "./TaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports